import { APPT_STATUS_LEGEND, apptStatusInfo } from '../data/appointmentStatuses.js'

/**
 * The appointment-status colour key, as a static panel under the day view.
 *
 * It was a popover behind a สถานะ button in the filter row until 2026-09-19 —
 * Ram moved it to the bottom of the calendar and dropped the button: always
 * there, out of the way, and one less control in a row that was already full.
 *
 * Labels, colours and meanings all come from data/appointmentStatuses.js. Do not
 * write them out here: a legend that disagrees with the badges it explains is
 * worse than no legend.
 */
export default function ApptStatusLegend({ className = '' }) {
  return (
    <div className={`rounded-xl border border-slate-200 bg-white px-4 py-3 ${className}`}>
      <div className="text-[12px] font-semibold uppercase tracking-wide text-slate-400 mb-2">ความหมายของสถานะนัดหมาย</div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-1">
        {APPT_STATUS_LEGEND.map((code) => {
          const t = apptStatusInfo(code)
          return (
            <div key={code} className="flex items-start gap-2.5 py-1">
              <span className={`mt-px flex-none inline-flex items-center justify-center min-w-[34px] px-1.5 py-0.5 rounded-md text-[12px] font-bold ring-1 ${t.pill}`}>{code}</span>
              <span className="min-w-0">
                <span className="block text-[13.5px] text-slate-700 leading-snug">{t.label}</span>
                {t.hint && <span className="block text-[12px] text-slate-400 leading-snug">{t.hint}</span>}
              </span>
            </div>
          )
        })}
      </div>
      <div className="mt-2 border-t border-slate-100 pt-2 text-[12px] text-slate-400 leading-snug">
        ★ = คนไข้ตอบเองผ่าน SMS หรือ Patient Portal · จอง 48 ชม. ที่หมดเวลาแล้วจะเป็นสีเทา
      </div>
    </div>
  )
}
